import { IconButton,InputAdornment, TextField } from '@mui/material';
import { Theme, useMediaQuery } from '@mui/system';
import React, { RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import TemplatesIcon from '@/features/Icons/TemplatesIcon';
interface CustomTextFieldProps {
  placeholderText: string;
  inputText: string;
  setInputText: (text: string) => void; // Ensure it expects a string as an argument
  handleBlur: () => void;
  isTouched: boolean;
  inputRef: React.RefObject<HTMLTextAreaElement | HTMLInputElement>;
  handleTemplateSelect: () => void;
  premium: boolean;
}

const InputFieldWithTemplates: React.FC<CustomTextFieldProps> = ({
                                                           placeholderText,
                                                           inputText,
                                                           setInputText,
                                                           handleBlur,
                                                           isTouched,
                                                           inputRef,
                                                           handleTemplateSelect,
                                                           premium
                                                         }) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return <TextField

    placeholder={placeholderText}
    variant="outlined"
    value={inputText}
    onBlur={handleBlur}
    onChange={(e) => setInputText(e.target.value)} // Correctly passes a string value
    fullWidth
    multiline
    rows={isSmallScreen ? 4 : 7}
    error={isTouched && !inputText}
    helperText={isTouched && !inputText ? <FormattedMessage id="home.text-generator.textarea.error" /> : ''}
    inputRef={inputRef}

    InputProps={{
      endAdornment: (
        <InputAdornment position="end" sx={{ position: 'absolute', bottom: '5%', right: '2%' }}>
          <IconButton  sx={{
            ':hover': { backgroundColor: 'transparent' }, // Removes hover background
          }}>
            <TemplatesIcon onSelectTemplate={handleTemplateSelect} isPremium={premium} />
          </IconButton>
        </InputAdornment>
      )
    }}

  />
};


export default InputFieldWithTemplates;
